module.exports = __webpack_public_path__ + "static/media/superHero_01.2dc231c0.jpg";